import React from "react";
import { Field, useFormikContext } from "formik";
import { FormControl, FormControlLabel, Grid, InputAdornment, Radio, RadioGroup, Typography } from "@material-ui/core";
import { Label } from "../../formInputs";
import { addSuffix, Financial } from "../../../pages/client/Kids/util";
import { ErrorCommon, EstimationErrorCommon, NumberTextField, TextFieldCommon } from "../../formikFormInputs";
import { required } from "../../../utils/validation";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";


export default function FinancialDependentQuestion(props: any) {
    const {childNo} = props;
    const { user: { role }} = useSelector((state: RootState) => state.auth);
    const formNames = addSuffix(childNo && childNo.toString());
    const {errors, handleBlur, handleChange, setFieldValue, touched, values} = useFormikContext<any>();
    const independentField = [
        {
            id: formNames.annualIncome,
            name: formNames.annualIncome,
            component: NumberTextField,
            allowMax100: false,
            validate: {required},
            thousandSeparator: true,
            placeholder: " Specify Recipient Income",
            variant: "outlined",
            className: "mt20",
            label: <Label label={"Specify Recipient Income"} required={true}/>,
            rowSize: 6,
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon" position="start">$</InputAdornment>,
            },
        }
    ];


    return (
            <>
                <Grid item xs={12}>
                    <Typography className="mt0 mb15 floatLeft w100" variant="body1" component="strong">
                        <Label
                                label={"Is the Recipient financially independent, or are you currently supporting them as a dependent?"}
                                required={true}
                        />
                    </Typography>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <RadioGroup
                                    name={formNames.financiallyDependent}
                                    row
                                    value={values.financiallyDependent}
                                    onChange={async (e) => {
                                        await setFieldValue(formNames.annualIncome, e.target.value === Financial.Independent ? null : 0);
                                        handleChange(e);
                                    }}
                            >
                                <FormControlLabel
                                        style={{display: "inline", marginBottom: 0}}
                                        value={Financial.Independent}
                                        control={<Field as={Radio} name={formNames.financiallyDependent}/>}
                                        label={
                                            <Typography variant="caption">They are financially independent</Typography>
                                        }
                                />
                                <FormControlLabel
                                        style={{display: "inline", marginBottom: 0}}
                                        value={Financial.Dependent}
                                        control={<Field as={Radio} name={formNames.financiallyDependent}/>}
                                        label={
                                            <Typography variant="caption">They are my financial dependent</Typography>
                                        }
                                />
                                <span style={{ width: "100%", float: "left" }}>
                                    <EstimationErrorCommon
                                            errors={errors}
                                            name={formNames.financiallyDependent}
                                            touched={touched}
                                    />
                                </span>
                            </RadioGroup>
                        </FormControl>

                        {
                                values[formNames.financiallyDependent] === Financial.Independent &&
                                independentField.map((field, index) => (
                                        <Grid item xs={12} key={index}>
                                            <TextFieldCommon
                                                    values={values}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    InputLabelProps={{shrink: true}}
                                                    {...field}
                                            />
                                            <ErrorCommon errors={errors} name={field.name} touched={touched}/>
                                        </Grid>
                                ))
                        }
                    </Grid>
                </Grid>
            </>
    );
};


